import { useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Avatar, Card, Loader } from "@aws-amplify/ui-react";
import { WorkoutSummary } from "./workout-summary";
import { Image } from "@aws-amplify/ui-react";
import { apiGetComments, apiGetLikesByPost, apiLikePost, apiSyncComments, apiSyncPosts } from "../../api/api";
import { setComments, appendComments, setLikes, likePost, deleteComment, updateComment } from "../../store/commentsSlice";
import { CommentCard } from "./comment-card";
import { TextAreaField, Button } from "@aws-amplify/ui-react";
import { updateCommentsCounter, updateLikeCounter, updatePost } from "../../store/postsSlice";
import { Placeholder } from "@aws-amplify/ui-react";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { TopMoversCard } from "./top-movers-card";

export const PostDetailsCard = ({ postId, onPublishComment, user, userName, onError }) => {
    const dispatch = useDispatch();
    const [commentContent, setCommentContent] = useState("")
    const post = useSelector((state) => {
        return state?.posts?.items?.find((value, index, _) => value.id === postId)
    })

    let isLikedByUser = false

    const likes = useSelector((state) => {
        isLikedByUser = (state?.comments?.likes[postId]?.find((e) => e.userId === user) !== undefined);
        return state?.comments?.likes[postId]
    })

    const [postLoading, setPostLoading] = useState(false)
    const [commentsLoading, setCommentsLoading] = useState(false)
    const [selectedComment, setSelectedComment] = useState(null)
    const [commentEditorValue, setCommentEditorValue] = useState("")

    const comments = useSelector((state) => {
        return state?.comments?.items[postId]
    })
    const hasMore = useSelector((state) => {
        return state?.comments?.hasMore ?? false
    })
    const lastEvaluatedKey = useSelector((state) => {
        return state?.comments?.lastEvaluatedKey
    })
    const [showAvatar, setShowAvatar] = useState(true)
    const [postToEdit, setPostToEdit] = useState(null)
    const [postContentEditorValue, setPostContentEditorValue] = useState("")
    const hasFetchedLikes = useRef(false)
    const fetchLikes = async () => {
        setPostLoading(true)
        if (!hasFetchedLikes.current) {
            const likesResponse = await apiGetLikesByPost(postId)
            dispatch(setLikes({
                postId: postId,
                likes: likesResponse.data?.likes
            }))
            hasFetchedLikes.current = true
        }
        setPostLoading(false)
    }

    const fetchComments = async () => {
        setCommentsLoading(true)
        const commentsResponse = await apiGetComments(postId, null)
        dispatch(setComments({
            postId: postId,
            comments: commentsResponse.data?.comments?.filter((value, index) => value.deleted !== true),
            hasMore: commentsResponse.data?.hasMore,
            lastEvaluatedKey: commentsResponse.data?.lastEvaluatedKey
        }))
        setCommentsLoading(false)
    }

    const fetchMore = async () => {
        setCommentsLoading(true)
        const commentsResponse = await apiGetComments(postId, lastEvaluatedKey)
        dispatch(appendComments({
            postId: postId,
            comments: commentsResponse.data?.comments?.filter((value, index) => value.deleted !== true),
            hasMore: commentsResponse.data?.hasMore,
            lastEvaluatedKey: commentsResponse.data?.lastEvaluatedKey
        }))
        setCommentsLoading(false)
    }


    useEffect(() => {
        if (post) {
            //console.log('post exists locally')
            //console.log(post)
        } else {
            //console.log('post doesnt exists, fetching..')
        }
        if (comments) {
            //console.log('comments cached')
            //console.log(comments)
        } else {
            //console.log('fetching comments')
            fetchComments()
        }
        if (likes) {
            //console.log('likes cached')
            //console.log(likes)
        } else {
            fetchLikes()
        }

    }, [postId])

    let payload = null
    try {
        payload = JSON.parse(post?.payload)

    } catch (e) {
        payload = null
    }

    return (
        <>
            <Card
                className="text-align-start post-card"
                variation="elevated">
                {postLoading &&
                    <div >
                        <Placeholder style={{
                            height: '150px'
                        }} />
                    </div>
                }
                {!postLoading && <div>
                    <div className="d-flex justify-content-start">
                        {showAvatar &&
                            <Image
                                className="post-avatar"
                                onError={() => { setShowAvatar(false) }}
                                src={`https://liftolog-media.s3.eu-central-1.amazonaws.com/avatars/${post?.author}.jpg`} />
                        }
                        {
                            !showAvatar &&
                            <Avatar className="post-avatar" />
                        }

                        <div>
                            <h5 >{post?.authorName}</h5>
                            <p className="small"> {(new Date(post?.timestamp)).toDateString()}</p>
                        </div>
                    </div>
                    <hr></hr>
                    {post?.imageUrl &&
                        <Image src={post?.imageUrl}>
                        </Image>
                    }
                    <p className="clickable" onClick={() => {
                        setPostContentEditorValue(post?.content)
                        setPostToEdit(post)
                    }}>
                        <span>{post?.content}</span>

                    </p>
                    <div className="d-flex w-100 justify-content-end">
                        <OverlayTrigger placement="left" overlay={
                            <Popover id="likes-popover">
                                <Popover.Header as="h6">People who liked the post</Popover.Header>
                                <Popover.Body>
                                    <ul>
                                        {likes?.map((like, index) => (
                                            <li key={index} className="no-bullet">{like.userName}</li>
                                        ))}
                                    </ul>
                                </Popover.Body>
                            </Popover>
                        }>
                            {({ ref, ...triggerHandler }) => (
                                <Button
                                    {...triggerHandler}
                                    ref={ref}
                                    onClick={async () => {
                                        try {
                                            const liked = !isLikedByUser
                                            const likeResult = await apiLikePost(
                                                postId,
                                                liked,
                                                user,
                                                userName
                                            )

                                            if (likeResult.data?.message === "ok") {
                                                dispatch(likePost({
                                                    postId: postId,
                                                    like: liked,
                                                    userId: user,
                                                    userName: userName
                                                }))
                                                dispatch(updateLikeCounter(
                                                    {
                                                        postId: postId,
                                                        like: liked,
                                                        userId: user
                                                    }
                                                ))
                                            }
                                        } catch (e) {
                                            onError("Network arror in apiLikePost")
                                        }

                                    }}
                                    variation="link">
                                    <div className="d-flex">
                                        <span
                                            className="material-symbols-outlined"
                                            style={{
                                                fontVariationSettings: `'FILL' ${isLikedByUser ? 1 : 0}`,
                                                cursor: 'pointer'
                                            }}>
                                            thumb_up
                                        </span>
                                        <span className="ms-2">
                                            {post?.likes}
                                        </span>
                                    </div>
                                </Button>
                            )
                            }
                        </OverlayTrigger>
                    </div>
                    {payload?.workoutSummary?.exercises?.length &&
                        <div>
                            <h6 className="mt-2 text-align-center">{`Workout Summary ${payload?.workoutSummary?.date}`}</h6>
                            <WorkoutSummary
                                workout={payload?.workoutSummary?.exercises}>
                            </WorkoutSummary>
                        </div>}
                    {payload?.topMovers?.length !== 0 &&
                        <TopMoversCard topMovers={payload?.topMovers} />
                    }
                </div>}
                <div>
                    <h6 className="mt-2">Comments {post?.comments}</h6>
                    <Card variation="elevated mb-2" className="text-align-start">
                        <TextAreaField
                            autoResize
                            size="small"
                            descriptiveText="Write a comment"
                            placeholder="Your comment.."
                            value={commentContent}
                            onChange={(e) => {
                                setCommentContent(e.target.value)
                            }}
                            errorMessage="There is an error"
                        />
                        <div className="d-flex mt-2 justify-content-end">
                            <Button
                                size="small"
                                loadingText="Wait.."
                                onClick={() => {
                                    onPublishComment(commentContent)
                                    setCommentContent("")
                                }}
                            >
                                Sumbit
                            </Button>
                        </div>
                    </Card>

                    {commentsLoading &&
                        <div className="d-flex justify-content-center mt-2 w-100">
                            <Loader className="me-2" />
                            <p>Loading..</p>
                        </div>}
                    {!commentsLoading && comments?.map((comment, index) =>
                        <div key={index}>
                            <CommentCard
                                comment={comment}
                                user={user}
                                onDeleteComment={async () => {
                                    try {
                                        const commentToDelete = { ...comment }
                                        commentToDelete.deleted = true
                                        commentToDelete.modified = Date.now()
                                        const syncCommentsResponse = await apiSyncComments([commentToDelete], user)
                                        if (syncCommentsResponse.data?.message === "ok") {
                                            dispatch(deleteComment(
                                                {
                                                    postId: postId,
                                                    commentId: comment.id
                                                }
                                            ))
                                            dispatch(updateCommentsCounter(
                                                {
                                                    postId: postId,
                                                    change: -1
                                                }
                                            ))
                                        }
                                    } catch (e) {
                                        onError("Network error in apiSyncComments")
                                        console.log('Error in apiSyncComments')
                                        console.log(e)
                                    }

                                }}
                                onCommentClicked={() => {
                                    setCommentEditorValue(comment.content)
                                    setSelectedComment(comment)
                                }}
                            />
                        </div>)}

                    {hasMore &&
                        <div className='d-flex justify-content-center mt-2'>
                            <Button onClick={async () => {
                                await fetchMore()
                            }}>
                                Load more
                            </Button>
                        </div>
                    }

                </div>

            </Card>
            <Modal
                show={postToEdit !== null}
                onHide={() => { setPostToEdit(null) }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit your post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TextAreaField
                        value={postContentEditorValue}
                        autoResize
                        onChange={(e) => {
                            setPostContentEditorValue(e.target.value)
                        }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="m-1" variation="default" onClick={() => {
                        setPostToEdit(null)
                    }}>
                        Close
                    </Button>
                    <Button className="m-1" variation="primary" onClick={async () => {
                        try {
                            const _postToUpdate = { ...postToEdit }
                            _postToUpdate.modified = Date.now()
                            _postToUpdate.content = postContentEditorValue
                            const postSyncResult = await apiSyncPosts([_postToUpdate], user)
                            if (postSyncResult.data?.message === "ok") {
                                dispatch(updatePost({
                                    postId: postToEdit.id,
                                    content: postContentEditorValue
                                }))
                            }
                        } catch (e) {
                            onError("Error in apiSyncPosts")
                            console.log(e)
                        }
                        setPostToEdit(null)
                    }}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={selectedComment !== null}
                onHide={() => {
                    setSelectedComment(null)
                    setCommentContent("")
                }}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit your comment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TextAreaField
                        value={commentEditorValue}
                        autoResize
                        onChange={(e) => {
                            setCommentEditorValue(e.target.value)
                        }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="m-1" variation="default" onClick={() => {
                        setSelectedComment(null)
                        setCommentContent("")
                    }}>
                        Close
                    </Button>
                    <Button className="m-1" variation="primary" onClick={async () => {
                        try {
                            const updatedComment = { ...selectedComment }
                            updatedComment.modified = Date.now()
                            updatedComment.content = commentEditorValue
                            const updateCommentResult = await apiSyncComments([updatedComment], user)
                            if (updateCommentResult.data?.message === "ok") {
                                dispatch(updateComment({
                                    postId: postId,
                                    comment: updatedComment
                                }))
                            }
                        } catch (e) {
                            onError("Network error in apiSyncComments")
                            console.log(e)
                        }
                        setSelectedComment(null)
                        setCommentContent("")
                    }}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}